import {Injectable} from "@angular/core";
import {ComponentStore} from "@ngrx/component-store";
import {AppState} from "../../store/store";
import {Store} from "@ngrx/store";
import {catchError, tap} from "rxjs/operators";
import {Observable, of, switchMap, withLatestFrom} from "rxjs";
import {NotificationComponentObject} from "../../classes/notification-component-object";
import {NotificationCenterService} from "../../services/notification-center.service";
import {selectSite} from "../../store/init/init.selectors";
import {Serializer, SerializerResponse} from "../../interfaces/serializer";
import { Site } from "../../interfaces/site";
import {notificationMarkAsRead} from "./notification.actions";
import {Notification} from "../../interfaces/notification";
import {closeNotificationMenu} from "../notification-center/notification-center.actions";

@Injectable()
export class NotificationStore extends ComponentStore<any> {
  public readonly loading$ = this.select(state => state.loading);

  public readonly markAsRead = this.effect((params$ : Observable<{ notification: NotificationComponentObject, closeMenu: boolean }>) => params$.pipe(
    tap((): void => this.patchState({loading: true})),
    withLatestFrom(this._store.select(selectSite)),
    switchMap(([params, site]: [{ notification: NotificationComponentObject, closeMenu: boolean }, Serializer<Site>]) => this._notificationCenterService.markAsRead(site, params.notification.payload).pipe(
      tap((response: SerializerResponse<Serializer<Notification>>): void => {
        this.patchState({loading: false});
        this._store.dispatch(notificationMarkAsRead({ notification: response.data }));
        if (params.closeMenu) {
          this._store.dispatch(closeNotificationMenu());
        }
      })
    )),
    catchError(error => {
      this.patchState({loading: false});
      return of(error);
    })
  ));

  constructor(
    private readonly _store: Store<AppState>,
    private readonly _notificationCenterService: NotificationCenterService
  ) {
    super({
      loading: false
    });
  }

}
